import { Container } from "./Container";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";

export function Faqs() {
  const { language } = useUserContext();
  const faqs = [
    [
      {
        question: getTranslation("landingpage", "FAQ_1", language),
        answer: getTranslation("landingpage", "FAQ_1A", language),
      },
      {
        question: getTranslation("landingpage", "FAQ_2", language),
        answer: getTranslation("landingpage", "FAQ_2A", language),
      },
    ],
    [
      {
        question: getTranslation("landingpage", "FAQ_3", language),
        answer: getTranslation("landingpage", "FAQ_3A", language),
      },

      {
        question: getTranslation("landingpage", "FAQ_4", language),
        answer: getTranslation("landingpage", "FAQ_4A", language),
      },
    ],
    [
      {
        question: getTranslation("landingpage", "FAQ_5", language),
        answer: getTranslation("landingpage", "FAQ_5A", language),
      },
      {
        question: getTranslation("landingpage", "FAQ_6", language),
        answer: getTranslation("landingpage", "FAQ_6A", language),
      },
    ],
  ];

  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="relative overflow-hidden py-20 sm:py-32"
    >
      <Container className="relative">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2
            id="faq-title"
            className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl"
          >
            {getTranslation("landingpage", "FAQ", language)}
          </h2>
          <p className="mt-4 text-lg tracking-tight text-slate-700 font-light">
            {getTranslation("landingpage", "FAQ_SUBTITLE", language)}{" "}
            <a
              href="https://www.instagram.com/simpleapp.shop/"
              target="_blank"
              rel="noreferrer"
              className="text-secondary hover:text-secondary-dark"
            >
              Instagram
            </a>
            .
          </p>
        </div>
        <ul
          role="list"
          className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3"
        >
          {faqs.map((column, columnIndex) => (
            <li key={columnIndex}>
              <ul role="list" className="flex flex-col gap-y-8">
                {column.map((faq, faqIndex) => (
                  <li key={faqIndex}>
                    <h3 className="font-display text-lg leading-7 text-slate-900">
                      {faq.question}
                    </h3>
                    <p className="mt-4 text-sm text-slate-700">{faq.answer}</p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
